import accountApi from '@/apis/other/accountAPI';
import internalApi from '@/apis/other/internalAPI';
import historyApi from '@/apis/history/historyAccessAPI';
import commonFn from '@/commons/commonFunction';
// import moduleDbOption from '@/stores/moduleDbOption';
import {ModuleContext} from '@/stores/moduleConst';
import {defineStore} from 'pinia';
import moment from 'moment';
import i18nEnum from '@/i18ns/vi/i18nEnum';
import AudittingLogAction from '@/commons/wildcards/constants/AudittingLogAction';
import AudittingLogScreen from '@/commons/wildcards/constants/AudittingLogScreen';

const now = new Date();
const state = {
  /**
   * Cờ đang xử lý
   */
  Loading: false,
  /**
   * Token đăng nhập
   */
  Token: null,
  /**
   * Thời điểm  token hết hạn
   */
  TokenExpired: null,
  /*
   * Trạng thái Collapse của left menu
   */
  LeftMenuCollapse: false,
  /**
   * Thông tin phân quyền
   * Key là subsystemCode, value sẽ là mảng string danh sách perrmission
   */
  Permission: {},
  /**
   * Thông tin thuê bao
   */
  License: {},
  /**
   * Thông tin tài khoản
   */
  User: {
    UserID: null,
    Email: null,
    FullName: null,
    Mobile: null,
    UserName: null,
  },
  /**
   * Thông tin config
   */
  ConfigInfo: {
    CurrentDate: new Date(now.getFullYear(), now.getMonth(), now.getDay()),
    CurrentDateText: '',
  },
  /**
   * Định dạng số
   */
  NumberFormat: {
    GeneralDecimalSeparator: ',',
    GeneralGroupSeparator: '.',
    QuantityDecimalDigits: 1,
    AmountDecimalDigits: 0,
    AmountOCDecimalDigits: 2,
    UnitPriceDecimalDigits: 1,
    UnitPriceOCDecimalDigits: 1,
    ExchangRateDecimalDigits: 2,
    CoefficientDecimalDigits: 2,
    AllocationDecimalDigits: 2,
  },
  OptionsData: {},
  /**
   * Ngôn ngữ hiện tại
   */
  Culture: 'vi',
  /**
   * Ngày hạch toán
   */
  PostedDate: new Date(),
  /**
   * Một số thông tin liên quan đến phiên làm việc hiện tại
   * Chỉ có 1 số thông tin ở đây, 1 số thông tin khi submit lên server sẽ lấy từ token: userid, databaseid, tenantid...
   */
  Context: {
    SessionId: null,
    UserId: null,
    DatabaseId: null,
    TenantId: null,
    Culture: null,
    UserName: null,
    OrganizationPackCodeType: null,
    BudgetYear: null,
    OrganizationID: null,
    OrganizationName: null,
    GroupTenantId: null,
    Version: null,
  },

  TenantType: i18nEnum.TenantType.Summary,

  /**
   * MISAID AccessToken
   */
  MISAIDAccessToken: null,
};

const actions = {
  /**
   * updateConfig
   * @param {*} payload
   */
  updateConfig(payload) {
    const currentDate = moment(payload.CurrentDate).toDate();
    this.ConfigInfo = {
      ...this.ConfigInfo,
      ...payload,
      CurrentDate: currentDate,
      CurrentDateText: moment(currentDate).format('YYYY-MM-DD HH:mm:ss'),
    };
  },

  /**
   * getConfigInfo
   * @param {*} payload
   */
  async getConfigInfo(payload) {
    try {
      this.updateConfig({CurrentDate: new Date()});
    } catch (ex) {
      commonFn.errorLogging('Lỗi lấy thông tin config:: ', ex);
    }
  },

  /**
   * Đăng nhập
   * @param {*} payload
   */
  async loginCode(payload) {
    this.Loading = true;
    const res = await accountApi.login(payload);

    this.Loading = false;

    if (res) {
      if (res.token) {
        this.updateToken(res);
      }

      return res;
    }
  },

  /**
   * Từ misaid sẽ gọi về callback api, trên api sẽ xử lý để chọn dữ liệu làm việc
   * Dựa theo phiên bản dữ liệu đó sẽ điều hướng về cụm api tương ứng và mã hóa thông tin user, database để truyền kèm
   * Client nhận dc token này sẽ gọi lên account api để đăng nhập
   * @param {*} payload
   * @param {*} isFingovCallback gọi đăng nhập từ Fingov
   *
   * Modified by DTHieu1 22.10.2024: Xử lý bổ sung đăng nhập từ Fingov
   */
  async loginCallback(payload, isFingovCallback = false) {
    this.Loading = true;
    var res = null;

    try {
      //Kiểm tra có phải đăng nhập từ Fingov không
      if (isFingovCallback) {
        res = await accountApi.loginCallbackFingov(payload);
      } else {
        res = await accountApi.loginCallback(payload);
      }

      if (res) {
        if (res.token) {
          this.updateToken(res);
          // const dbOptions = moduleDbOption.state.dbOptions || {};
          // if (Object.keys(dbOptions).length == 0) {
          //   context.dispatch(`${ModuleDbOption}/getDbOptions`, '', {root: true});
          // }
          // xử lý sau khi có dboption

          if (res.misaid_access_token) {
            this.MISAIDAccessToken = res.misaid_access_token;
          }

          // Clean up client info sau khi login thành công
          this.clearLoginClientInfo();
        }

        return res;
      }
    } catch (error) {
      // Clear client info nếu có lỗi
      this.clearLoginClientInfo();
      throw error;
    } finally {
      this.Loading = false;
    }
  },

  /**
   * Xóa thông tin client login đã lưu trong localStorage
   * Gọi sau khi login thành công hoặc thất bại để cleanup
   */
  clearLoginClientInfo() {
    try {
      if (window._misaId && window._misaId.clientId) {
        localStorage.removeItem(window._misaId.clientId);
      }
    } catch (error) {
      console.error('Lỗi khi clear client info:', error);
    }
  },

  /**
   * Thực hiện 1 số hành động khác sau login
   * NXPHONG 11/12/2024
   */
  async executeAfterLogin() {
    try {
      let termsPrivacy = await internalApi.executeAfterLogin();
      if (termsPrivacy && window._misaAgreementLib.IsActiveMisaAgreement) {
        this.Context.TermsPrivacy = termsPrivacy;
      }
    } catch (ex) {
      console.log(ex);
    }
  },

  /**
   * xác nhận thỏa thuận mua hàng
   * NXPHONG 11/12/2024
   */
  async acceptAgreementTermsPrivacy(proxy) {
    try {
      // xác nhận thỏa thuận với misa ID
      let accept = await internalApi.acceptAgreementTermsPrivacy();

      // xác nhận chưa thành công => trả về thông tin thỏa thuận, gán lại context và cho reload trang
      if (accept) {
        this.Context.TermsPrivacy = accept;
        location.reload();
      } else {
        // thành công ~ các thông tin thỏa thuận/ chính sách đều null
        delete this.Context.TermsPrivacy;
        proxy.$router.push('/');
      }
    } catch (err) {
      proxy.loading = false;
      console.log(err);
    }
  },
  /**
   * Lấy lịch sử thỏa thuận hoặc chính sách
   * @param {*} payload
   * NXPHONG 11/12/2024
   */
  async getHistoryAgreement(payload) {
    try {
      return await internalApi.getHistoryAgreement(payload);
    } catch (error) {
      return null;
    }
  },
  /**
   * Đăng xuất
   */
  async logout() {
    this.Loading = true;
    if (this.Context && this.Context.SessionId) {
      //gọi API save Auditting Log
      try {
        await historyApi.saveLog({
          action: AudittingLogAction.Logout,
          actionName: 'Đăng xuất',
          screen: AudittingLogScreen.Logout,
          description: 'Đăng xuất',
        });
      } catch (ex) {
        console.log('Lỗi ghi log đăng xuất:: ', ex);
      }

      // gọi api logout
      await accountApi.logout({
        SessionId: this.Context.SessionId,
      });
    }
    const IsPlatformCore = this.Context?.IsPlatformCore;
    this.updateLogout();
    this.Loading = false;
    if(IsPlatformCore){
      let url = window._ql.platformUrl;
      location.href = `${url}/logout`;
    }else{
      let url = window._misaId.getUrl('logoutUrl');
      location.href = url;
    }
  },

  /**
   * Lấy token
   * @param {*} payload
   */
  async getToken(payload) {
    this.Loading = true;
    const res = await accountApi.getToken(payload);

    this.Loading = false;

    if (res) {
      this.updateToken(res);
      return res;
    }
  },

  updateToken(payload) {
    this.Token = payload.token;
    this.TokenExpired = new Date().addSeconds(payload.tokenTimeout);
    this.User = payload.user;
    this.Context = payload.context;
    this.TenantType = payload.context?.TenantType;
    this.Context.ShowWarningDateTopClient = payload.context.ShowWarningDateTop;
  },

  updateLogout() {
    this.Token = null;
    this.TokenExpired = null;
    this.User = null;
    this.Context = null;
    this.MISAIDAccessToken = null;

    //xóa all storage
    sessionStorage.clear();
  },

  /**
   * Lấy thông tin phân quyền
   * @param {*} payload payload
   */
  async getPermission(payload) {
    this.Loading = true;

    // request
    const res = await accountApi.getPermission(payload);

    this.Loading = false;

    if (res) {
      this.Permission = res;
    }

    return res;
  },

  /**
   * Đăng xuất
   */
  async logoff() {
    await accountApi.logoff();

    // remove token
    this.removeToken();
  },
  /**
   * remove token
   */
  removeToken() {
    this.Token = null;
    this.Context = null;
    this.TokenExpired = null;
    this.User = null;
    this.Permission = null;
    this.MISAIDAccessToken = null;
  },
  /*
   * Set trạng thái collapse của left menu
   */
  setLeftMenuCollapse(payload) {
    this.LeftMenuCollapse = payload;
  },

  /*
   * Get trạng thái collapse của left menu
   */
  getLeftMenuCollapse() {
    return this.LeftMenuCollapse;
  },

  /**
   * Cập nhật posted date
   * @param {*} payload
   * tbngoc 28/07/2022
   */
  updatePostedDateContext(payload) {
    if (payload && payload.PostedDate) {
      this.PostedDate = payload.PostedDate;
    }
  },
  hasExpiredToken() {
    if (!this.Token) return true;
    if (!this.TokenExpired) return true;
    //TODO => xem lại logic đoạn này
    //NMQUANG1: 08.07.2024: Bổ sung new Date(...)
    if (this.TokenExpired && new Date(this.TokenExpired) > new Date()) {
      return false;
    }
    return true;
  },
  /**
   * cập nhật client_id vào context
   * @param {*} state
   * @param {*} clientid
   */
  updateSocketClientId(clientid) {
    this.BumasClientId = clientid;
  },
  /**
   * Cập nhật lại biến để show popup
   * @param {*} state
   * @param {*} payload
   */
  changeShowWarningDate(state, payload) {
    this.Context.ShowWarningDate = false;
  },
  /**
   * Cập nhật lại biến sử dụng Ihos
   * @param {*} state
   * @param {*} payload
   */
  updateIHOSSyncDataType(payload) {
    this.Context.IHOSSyncDataType = payload;
  },
  
  /**
   * Cập nhật lại biến để show noti top
   * @param {*} state
   * @param {*} payload
   */
  changeShowWarningDateTop(state, payload) {
    this.Context.ShowWarningDateTop = payload;
  },

  changeShowWarningDateTopClient(state, payload) {
    this.Context.ShowWarningDateTopClient = payload;
  },
};

const getters = {
  CurrentDate(state) {
    return this.ConfigInfo.CurrentDate;
  },
};

export const useContextStore = defineStore(ModuleContext, {
  state: () => state,
  actions,
  getters: getters,
  persist: {
    storage: localStorage,
    beforeRestore: (ctx, action) => {},
    afterRestore: (ctx, action) => {},
    // eslint-disable-next-line no-undef
    debug: process.env.NODE_ENV !== 'production',
  },
});
